import React, { useCallback, useEffect, useState } from "react";
import { Grid2, Typography, Tooltip, Paper, Card, Box } from "@mui/material";
//import Header from "../../Controller/HeaderController/Header";
import ListItem from "@mui/material/ListItem";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ViewBinInMap from "./ViewBinInMap";
import { MultiSelect } from "react-multi-select-component";

import Badge from "@mui/material/Badge";
import MailIcon from "@mui/icons-material/Mail";

import ProjectList from "../../../Utils/projectList";
import BinCategory from "../../../Utils/BinLegend";
import moment from "moment";
import { useTranslation } from "react-i18next";

const BinComponent = () => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState([
    {
      label: "Standard Grey Non-Ashtray Bin(Old Design)",
      value: "Standard Grey Non-Ashtray Bin (Old Design)",
    },
    {
      label: "Standard Grey Ashtray Bin(Old Design)",
      value: "Standard Grey Ashtray Bin (Old Design)",
    },
    {
      label: "Standard Grey Non-Ashtray Bin(Ausko)",
      value: "Standard Grey Non-Ashtray Bin (Ausko)",
    },
    {
      label: "Standard Grey Ashtray Bin(Ausko)",
      value: "Standard Grey Ashtray Bin (Ausko)",
    },
    {
      label: "Standard Green Non-Ashtray Bin",
      value: "Standard Green Non-Ashtray Bin",
    },
    {
      label: "Standard Green Ashtray Bin",
      value: "Standard Green Ashtray Bin",
    },
    {
      label: "STB bin (Orchard)",
      value: "STB bin (Orchard)",
    },
    {
      label: "Recycle Blue Bin",
      value: "Recycle Blue Bin",
    },
    {
      label: "Big Belly Recycle Bin",
      value: "Big Belly Recycle Bin",
    },
    {
      label: "Npark Metal Bin",
      value: "Npark Metal Bin",
    },
    {
      label: "Grey Monkey Bin(Old Design)",
      value: "Grey Monkey Bin (Old Design)",
    },
    {
      label: "Steel Cigarette Bin",
      value: "Steel Cigarette Bin",
    },
    {
      label: "Npark Green Bin",
      value: "Npark Green Bin",
    },
    {
      label: "Green Monkey Bin(Old Design)",
      value: "Green Monkey Bin (Old Design)",
    },
    {
      label: "New Monkey Bin(Ausko)",
      value: "New Monkey Bin (Ausko)",
    },
    {
      label: "URA bin",
      value: "URA bin",
    },
  ]);
  const [selectedProject, setSelectedProject] = useState(ProjectList);

  const [bintypes, setBinTypes] = useState(BinCategory);

  const getProjectDetails = useCallback(
    (
      e: {
        label: string;
        value: string;
        category: string;
        color: string;
        count: number;
      }[]
    ) => {
      setBinTypes([...e]);
    },
    []
  );

  // const handleChange = (selectedValue) => {
  //   /* if (selectedValue.length == 1 || selectedValue.length > 1) {
  //         let arr = selectedValue.reverse();
  //         setSelectedProject(arr[0]);
  //       } else {
  //           setSelectedProject(null);
  //       } */
  // };

  const getProjectDropDown = () => {
    return (
      <div style={{ marginTop: "40px", width: "250px" }}>
        {" "}
        {/* Set a fixed width */}
        <MultiSelect
          options={ProjectList}
          value={selectedProject}
          onChange={setSelectedProject}
          labelledBy="Select"
          disableSearch // Disable search for simplicity (optional)
          overrideStrings={{ selectSomeItems: "Select Project" }}
        />
      </div>
    );
  };

  const getBinDropDown = () => {
    return (
      <div style={{ marginTop: "40px", width: "250px" }}>
        {" "}
        {/* Set a fixed width */}
        <MultiSelect
          options={BinCategory}
          value={selected}
          onChange={setSelected}
          labelledBy="Select"
          hasSelectAll={true} // Enable select all option
          overrideStrings={{ selectSomeItems: "Select Bin Type" }}
        />
      </div>
    );
  };

  return (
    <Grid2 container spacing={1} style={{ position: "relative" }}>
      <Grid2 size={{ xs: 12, md: 12, sm: 12 }}>
        {/* Dropdown container positioned over the map */}
        <div
          style={{
            position: "absolute",
            zIndex: 999,

            left: "10px",
            display: "flex",
            flexDirection: "row",
            gap: "10px",
          }}
        >
          {getProjectDropDown()}
          {getBinDropDown()}
        </div>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 12, sm: 12 }}>
        <Card sx={{ padding: 1, marginTop: "15px" }}>
          <ViewBinInMap
            binType={selected}
            project={selectedProject}
            setProjectDetails={(
              e: {
                label: string;
                value: string;
                category: string;
                color: string;
                count: number;
              }[]
            ) => getProjectDetails(e)}
          />
        </Card>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 12, sm: 12 }} style={{ padding: `10px` }}>
        <Grid2 container spacing={2}>
          {bintypes.map((item, index) => (
            <Grid2 key={index} size={{ xs: 1.5, md: 1.5, sm: 1.5 }}>
              <Tooltip title={item.category} placement="top">
                <ListItem
                  style={{
                    display: "flex",
                    alignItems: "center", // Aligns all items vertically centered
                  }}
                >
                  <Badge
                    badgeContent={item.count}
                    color="primary"
                    showZero
                    max={4000}
                    style={{
                      display: "flex",
                      alignItems: "center", // Ensures the dot is aligned correctly
                    }}
                  >
                    <FiberManualRecordIcon
                      style={{ color: item.color, fontSize: "20px" }}
                    />
                  </Badge>
                  <Typography
                    variant="body2"
                    style={{
                      fontSize: "10px",
                      marginLeft: "18px", // Fine-tune spacing to align with the center of the dot
                      lineHeight: "12px", // Matches the vertical alignment with the dot
                    }}
                  >
                    {item.category}
                  </Typography>
                </ListItem>
              </Tooltip>
            </Grid2>
          ))}
        </Grid2>
      </Grid2>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          textAlign: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "#000000",
            marginBottom: 1,
          }}
        >
          {t("global.copyRight")} © {moment().year()},{" "}
          {t("global.copyRightText")}
        </Typography>
      </Box>
    </Grid2>
  );
};

export default BinComponent;
